export default (state = '', action) => {
  if (action.type === 'on_filtrar_itens') {
    return action.valor;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/filtroItensReducer.js